import React from 'react';
import { ChevronRightIcon } from '@/components/icons/ChevronRightIcon';
import { Skeleton } from '@design-system/Skeleton';
import { getBackgroundImageUrl } from '@utils/nutrition/getImageUrl';
import { useNavigate } from 'react-router-dom';
import { NUTRITION_PATH } from '@/constants/paths';
import { EventTracker } from '@/utils';

interface NutritionPlanSectionProps {
  isLoading: boolean;
  isOHI?: boolean;
}

export const NutritionPlanSection: React.FC<NutritionPlanSectionProps> = ({
  isLoading,
  isOHI = false,
}) => {
  const navigate = useNavigate();
  const onClickNutritionPlanSection = () => {
    EventTracker.trackEvent('health', 'health_myNutrition');
    navigate(`${NUTRITION_PATH}`);
  };

  return isLoading ? (
    <div className="dark w-full p-5 bg-cover bg-center rounded-lg border mt-12" data-testid="health-nutrition-skeleton">
      <Skeleton className="h-9 w-[50%] mb-4 rounded-lg" />
      <Skeleton className="h-5 w-[80%] mb-4 rounded-lg" />
      <Skeleton className="h-5 w-[60%] rounded-lg" />
    </div>
  ) : (
    <div
      className="dark w-full p-5 bg-cover bg-center rounded-lg border mt-12"
      style={{
        height: '280px',
        backgroundImage: isOHI
          ? `url(${getBackgroundImageUrl('personalized_health_bg.png')})`
          : `url(${getBackgroundImageUrl('nutrition_bg.png')})`,
      }}
      data-testid="health-nutrition-section"
    >
      <button className="text-left cursor-default">
        <h2 className="dark typography-h1 text-primary mb-2" data-testid="health-nutrition-title">
          Nutrition is your health's greatest ally
        </h2>
        <p className="dark typography-body text-primary mb-6 lg:w-[22rem]" data-testid="health-nutrition-description">
          Dig into your personalized foods and ingredients to learn how they can
          improve your scores.
        </p>

        <span
          className="flex items-center cursor-pointer"
          onClick={onClickNutritionPlanSection}
          data-testid="health-nutrition-link"
        >
          <p className="dark typography-body text-primary">My Nutrition</p>
          <ChevronRightIcon className="text-white pt-0.5 ml-1" />
        </span>
      </button>
    </div>
  );
};
